import { Outlet, useLocation } from "react-router-dom";
import GirlPower from "../components/landingPages/girlPower/GirlPower";
import ShowStars from "../components/landingPages/showStars/ShowStars";

require('./root.css');
require('../components/landingPages/landingPages.css')

const Root = () => {
  const hostname = window.location.hostname;
  const location = useLocation(); // Para obtener la ruta actual
  
  // Condicional para mostrar NextGeneration solo en la raíz ("/")
  
  if (location.pathname === "/"){
    if (
      hostname === 'localhost' ||
      hostname.includes('girlpower.com.co') ||
      hostname.includes('patinajenextgeneration.com')
    ){
      return <GirlPower />;
    }
    if(hostname.includes('showstars.com.co')){
      return <ShowStars />;
    }
  }

  return (
    <div className="w-100 h-100">
      {/* Aquí renderizamos las rutas hijas */}
      <Outlet />
    </div>
  );
};

export default Root;
